import {AfterViewInit, Component, EventEmitter, Input, Output} from '@angular/core';
import {FieldOfInterest} from "../../interfaces/field-of-interest";
import {ProfessionsService} from "../../services/professions.service";
import {ProvidersService} from "../../services/providers.service";
import {AnimationItem} from "lottie-web";
import {StoryTheme} from "../../story/card/story-theme";
import {LottieHelperService} from "../../services/lottie-helper.service";

@Component({
  selector: 'brt-interest-field-card',
  templateUrl: './interest-field-card.component.html',
  styleUrls: ['./interest-field-card.component.scss']
})
export class InterestFieldCardComponent implements AfterViewInit {

  @Output('animationEnd') animationEnd = new EventEmitter<number>();
  @Input('addRoughHeadline') addRoughHeadline = false;
  @Input('field') set setField(val: FieldOfInterest) {
    this.field = val;

    this.title = val.name;

    const titleParts = val.name.split('</br>');
    if(titleParts.length > 1) {
      titleParts[1] = "<em>" + titleParts[1] + "</em>";
    }

    this.title = titleParts.join("<br/>");

    //console.warn(val.name);

    this.hasAnimation = val.lottieSrc.indexOf(".json") !== -1;

    const professionFilterLink = '/' +  this.professionsService.getFilterUrl(1, [], "", [], "", false, [], [this.field.id]);
    const professionFilterLinkHashSplit =  professionFilterLink.split("#");
    this.professionFilterLink = professionFilterLinkHashSplit[0];
    if(professionFilterLinkHashSplit.length > 0) this.professionFilterLinkFragment = professionFilterLinkHashSplit[1];

    const schoolCompanyFilterLink = '/' + this.providersService.getFilterUrl(1, [], [this.field.id], [], "", [], "", 0, "", false, false, -1,{lat: 0, lng: 0});
    const schoolCompanyFilterLinkHashSplit =  schoolCompanyFilterLink.split("#");
    this.schoolCompanyFilterLink = schoolCompanyFilterLinkHashSplit[0];
    if(schoolCompanyFilterLinkHashSplit.length > 0) this.schoolCompanyFilterLinkFragment = schoolCompanyFilterLinkHashSplit[1];
  }

  @Input('play-anim') set setAnimationState(val: boolean) {
    this.animForcePlay = val;
    if(val && this.animation) {
      this.lottieHelperService.playAnimation(this.animation, this.desiredFPS);
    }

  };

  title: string = "";

  animForcePlay = false;
  animState = false;

  field!: FieldOfInterest;
  professionFilterLink = "";
  professionFilterLinkFragment = "";
  schoolCompanyFilterLink = "";
  schoolCompanyFilterLinkFragment = "";

  animation?: AnimationItem;
  hasAnimation: boolean = false;
  isMouseOnCard = false;

  constructor(private professionsService: ProfessionsService, private providersService: ProvidersService, private lottieHelperService: LottieHelperService) {
  }

  ngAfterViewInit() {

  }
  // bindedAnim = this.updAnim.bind(this);
  desiredFPS = 12;
  thenTime = Date.now();
  desiredFrameTime = 1000 / this.desiredFPS;

  onLottieAnimatedCreated($event: AnimationItem) {
    this.animation = $event;
    // if(this.animForcePlay) this.runAnim();

    if(this.animForcePlay) {
      this.lottieHelperService.playAnimation($event, this.desiredFPS);
    }
    // this.runAnim();
    // this.animation.frameRate = 1;
    // this.animation.frameMult = 0.0000120;
    // this.animation.frameRate = 1;
    // console.log(this.animation);
    // console.log(this.animation.frameRate)
  }

  // runAnim() {
  //   if(!this.animState) {
  //     this.animState = true;
  //     window.requestAnimationFrame(this.bindedAnim);
  //   }
  // }

  // updAnim() {
  //   const now = Date.now();
  //   const elapsed = now - this.thenTime;
  //   if (elapsed > this.desiredFrameTime) {
  //     if(this.animation) {
  //       let nextFrame = this.animation.currentFrame + 1;
  //       if(nextFrame === this.animation.totalFrames) nextFrame = 0;
  //
  //       // console.log("Next Frame is", nextFrame, this.animation.totalFrames);
  //       this.animation.goToAndStop(nextFrame, true);
  //       this.thenTime = now;
  //
  //
  //       // if(nextFrame === 0 && !this.isMouseOnCard) {
  //       //   this.animationEnd.emit(this.field.id);
  //       // }
  //
  //       // if(nextFrame !== 0 || this.isMouseOnCard) {
  //       //   window.requestAnimationFrame(this.bindedAnim);
  //       //   return;
  //       // }
  //
  //       window.requestAnimationFrame(this.bindedAnim);
  //       return;
  //     }
  //   } else {
  //     window.requestAnimationFrame(this.bindedAnim);
  //     return;
  //   }
  //   this.animState = false;
  // }

  onMouseEnter() {
    this.isMouseOnCard = true;
    // this.runAnim();
    if(this.animation) {
      this.lottieHelperService.playAnimation(this.animation, this.desiredFPS);
    }
    // if(this.animation) {
    //   this.animation.setLoop(true);
    //   this.animation.play();
    // }
  }

  onMouseLeave() {
    this.isMouseOnCard = false;
    // if(this.animation) {
    //   this.animation.setLoop(false);
    // }
  }

  protected readonly StoryTheme = StoryTheme;
}
